var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcategoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 230,
    viewBox: "0 0 231 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09326 124.005H96.9319C100.769 124.005 103.907 127.735 103.907 132.287V219.506C103.907 224.066 100.771 227.793 96.9319 227.793H7.09326C3.25952 227.793 0.118221 224.066 0.118221 219.506V132.287C0.118221 127.735 3.25952 124.005 7.09326 124.005ZM133.654 0H223.494C227.333 0 230.469 3.72678 230.469 8.28486V95.5038C230.469 100.062 227.333 103.785 223.494 103.785H133.654C129.816 103.785 126.684 100.062 126.684 95.5038V8.28486C126.684 3.72678 129.816 0 133.654 0ZM6.96941 0H96.8137C100.651 0 103.789 3.72678 103.789 8.28486V95.5038C103.789 100.062 100.653 103.785 96.8137 103.785H6.96941C3.13567 103.785 0 100.062 0 95.5038V8.28486C0 3.72678 3.13567 0 6.96941 0ZM133.772 126.215H223.612C227.446 126.215 230.587 129.942 230.587 134.502V221.721C230.587 226.273 227.446 230 223.612 230H133.772C129.934 230 126.797 226.273 126.797 221.721V134.502C126.797 129.942 129.934 126.215 133.772 126.215Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcategoria);
export default __webpack_public_path__ + "static/media/icategoria.56943f38dbe9a6c829b02c35d2eeabfa.svg";
export { ForwardRef as ReactComponent };